/**
 * JS del sitio público.
 *
 * Sin JS en línea ni atributos on*= en el HTML: la CSP del .htaccess declara
 * `script-src 'self'` y bloquearía cualquiera de los dos. Todo se engancha
 * desde aquí por clase o por data-attribute.
 */

document.addEventListener('DOMContentLoaded', () => {
  menuMovil();
  revelarAlHacerScroll();
  galeriaAsincrona();
  lightboxGaleria();
  formularioWhatsApp();
  verContrasena();
  avisoEmergente();
});

/**
 * Aviso emergente programado.
 *
 * El servidor decide CUÁL toca hoy y lo pinta oculto; aquí solo se decide si
 * se enseña y se gestiona el cierre.
 *
 * SE VE UNA VEZ POR VISITA. Se recuerda en sessionStorage y no en
 * localStorage a propósito: así reaparece la próxima vez que alguien entre al
 * sitio, pero NO vuelve a saltar al navegar del inicio al menú dentro de la
 * misma visita, que era justo lo que molestaba.
 *
 * La clave incluye la fecha de modificación del aviso (la pone el servidor en
 * data-aviso), así que si el cliente corrige el texto el aviso vuelve a salir
 * aunque ya se hubiera cerrado.
 */
function avisoEmergente() {
  const aviso = document.querySelector('.aviso-emergente');
  if (!aviso) return;

  const clave = 'aviso-visto:' + aviso.dataset.aviso;

  // El modo incógnito y algunos navegadores con el almacenamiento bloqueado
  // lanzan al tocar sessionStorage. Ahí se prefiere mostrar el aviso a
  // romper la página.
  const recordado = (accion, valor) => {
    try {
      return accion === 'leer'
        ? sessionStorage.getItem(clave)
        : sessionStorage.setItem(clave, valor);
    } catch {
      return null;
    }
  };

  if (recordado('leer')) return;

  const botonCerrar = aviso.querySelector('.aviso-emergente__cerrar');
  const focoPrevio = document.activeElement;

  const cerrar = () => {
    aviso.hidden = true;
    recordado('guardar', '1');
    document.removeEventListener('keydown', alPulsarTecla);
    if (focoPrevio instanceof HTMLElement) focoPrevio.focus();
  };

  function alPulsarTecla(e) {
    if (e.key === 'Escape') {
      cerrar();
      return;
    }

    // Encierro del foco: mientras el diálogo esté abierto, el tabulador no
    // debe llevar a los enlaces de detrás, que están tapados.
    if (e.key !== 'Tab') return;

    const focoables = aviso.querySelectorAll(
      'button, a[href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
    );
    if (!focoables.length) return;

    const primero = focoables[0];
    const ultimo = focoables[focoables.length - 1];

    if (e.shiftKey && document.activeElement === primero) {
      e.preventDefault();
      ultimo.focus();
    } else if (!e.shiftKey && document.activeElement === ultimo) {
      e.preventDefault();
      primero.focus();
    }
  }

  aviso.hidden = false;
  botonCerrar?.focus();

  botonCerrar?.addEventListener('click', cerrar);
  document.addEventListener('keydown', alPulsarTecla);

  // Tocar fuera de la tarjeta también cierra, que es lo que espera cualquiera.
  aviso.addEventListener('click', (e) => {
    if (e.target === aviso) cerrar();
  });
}

/** Menú hamburguesa del header. */
function menuMovil() {
  const toggle = document.querySelector('.site-header__toggle');
  const nav = document.querySelector('.nav');
  if (!toggle || !nav) return;

  const sincronizar = (abierto) => {
    nav.classList.toggle('nav--abierta', abierto);
    toggle.setAttribute('aria-expanded', String(abierto));
    toggle.setAttribute('aria-label', abierto ? 'Cerrar menú' : 'Abrir menú');
  };

  toggle.addEventListener('click', () => {
    sincronizar(!nav.classList.contains('nav--abierta'));
  });

  nav.querySelectorAll('.nav__link').forEach((enlace) => {
    enlace.addEventListener('click', () => sincronizar(false));
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && nav.classList.contains('nav--abierta')) {
      sincronizar(false);
      toggle.focus();
    }
  });
}

/** Entrada progresiva de los bloques al entrar en pantalla. */
function revelarAlHacerScroll() {
  const elementos = document.querySelectorAll('.reveal');
  if (!elementos.length) return;

  // Sin IntersectionObserver se muestra todo de golpe: nunca se deja
  // contenido invisible.
  if (!('IntersectionObserver' in window)) {
    elementos.forEach((el) => el.classList.add('reveal--visible'));
    return;
  }

  const observador = new IntersectionObserver((entradas) => {
    entradas.forEach((entrada) => {
      if (!entrada.isIntersecting) return;
      entrada.target.classList.add('reveal--visible');
      observador.unobserve(entrada.target);
    });
  }, { threshold: 0.15 });

  elementos.forEach((el) => observador.observe(el));
}

/**
 * Galería: cambiar de filtro o de página sin recargar.
 *
 * POR QUÉ SE PIDE HTML Y NO JSON
 *   El marcado de cada foto lo arma mediaResponsiva() en PHP, que mira el
 *   disco para decidir si ofrece avif, si ofrece webp, y si el respaldo es
 *   .png o .jpg según la imagen lleve transparencia. Nada de eso se puede
 *   averiguar desde el navegador. Pintar las tarjetas aquí obligaría a
 *   duplicar el marcado —una copia en PHP y otra en JS— y aun así el <picture>
 *   saldría mal. Así que el servidor manda el fragmento ya renderizado, desde
 *   la MISMA vista que pinta la página completa.
 *
 * POR QUÉ NO SE USA innerHTML
 *   DOMParser crea un documento inerte: no ejecuta scripts, no carga imágenes
 *   y no dispara onerror. Encima el querySelector de abajo actúa de filtro: si
 *   la respuesta trajera otra cosa (un error de PHP, una redirección al login),
 *   no se encuentra `.galeria-resultado` y no entra nada al DOM.
 *
 * SIN JAVASCRIPT ESTO SIGUE FUNCIONANDO
 *   Los filtros y la paginación son enlaces de verdad. Aquí solo se
 *   interceptan. Si algo falla, no se llama a preventDefault y el navegador
 *   sigue el enlace como siempre.
 */
function galeriaAsincrona() {
  const contenedor = document.querySelector('.galeria-resultado');
  const filtros = document.querySelector('.pill-nav');
  if (!contenedor) return;

  const enCurso = { peticion: null };

  const marcarFiltroActivo = (url) => {
    if (!filtros) return;
    const destino = new URL(url, location.origin);
    filtros.querySelectorAll('.pill-nav__item').forEach((enlace) => {
      const suyo = new URL(enlace.getAttribute('href'), location.origin);
      const activo = suyo.searchParams.get('filtro') === destino.searchParams.get('filtro');
      enlace.classList.toggle('pill-nav__item--activo', activo);
      if (activo) {
        enlace.setAttribute('aria-current', 'page');
      } else {
        enlace.removeAttribute('aria-current');
      }
    });
  };

  const cargar = async (url, empujarHistorial) => {
    // Si el visitante hace clic dos veces seguidas, la primera se abandona:
    // sin esto, la respuesta lenta podría pisar a la rápida.
    if (enCurso.peticion) enCurso.peticion.abort();
    const control = new AbortController();
    enCurso.peticion = control;

    const destino = new URL(url, location.origin);
    destino.searchParams.set('fragmento', '1');

    contenedor.setAttribute('aria-busy', 'true');
    contenedor.classList.add('galeria-resultado--cargando');

    try {
      const respuesta = await fetch(destino, {
        signal: control.signal,
        headers: { 'X-Requested-With': 'fetch' },
      });

      if (!respuesta.ok) throw new Error(`HTTP ${respuesta.status}`);

      const tipo = respuesta.headers.get('content-type') || '';
      if (!tipo.includes('text/html')) throw new Error('respuesta inesperada');

      const doc = new DOMParser().parseFromString(await respuesta.text(), 'text/html');
      const nuevo = doc.querySelector('.galeria-resultado');
      if (!nuevo) throw new Error('el fragmento no trae la rejilla');

      contenedor.replaceChildren(...nuevo.children);
      marcarFiltroActivo(url);

      if (empujarHistorial) history.pushState({ galeria: true }, '', url);

      // Al cambiar de página, el visitante espera ver el principio de la
      // rejilla y no el punto donde estaba.
      contenedor.scrollIntoView({ block: 'start', behavior: 'smooth' });
      return true;
    } catch (error) {
      if (error.name === 'AbortError') return true;   // la abandonamos nosotros
      return false;                                    // que el enlace haga su trabajo
    } finally {
      contenedor.removeAttribute('aria-busy');
      contenedor.classList.remove('galeria-resultado--cargando');
    }
  };

  // Delegación: la paginación se reemplaza en cada carga, así que engancharla
  // nodo a nodo dejaría de funcionar en cuanto se pasara de página.
  document.addEventListener('click', (e) => {
    const enlace = e.target.closest('.pill-nav__item, .paginacion__enlace');
    if (!enlace || !enlace.getAttribute('href')) return;
    if (e.metaKey || e.ctrlKey || e.shiftKey || e.button !== 0) return;  // abrir en otra pestaña

    const url = enlace.getAttribute('href');
    if (!url.startsWith('/galeria')) return;

    e.preventDefault();
    cargar(url, true).then((bien) => {
      if (!bien) location.href = url;   // el fetch falló: recarga normal
    });
  });

  // El botón atrás tiene que devolver el filtro y la página anteriores.
  window.addEventListener('popstate', () => {
    if (location.pathname.startsWith('/galeria')) {
      cargar(location.pathname + location.search, false);
    }
  });
}

/**
 * Vista ampliada de una foto de la galería.
 *
 * DELEGACIÓN, NO UN OYENTE POR FOTO
 *   Antes se recorrían las fichas y se les enganchaba un click a cada una. Al
 *   paginar sin recargar, las fotos de la página 2 son nodos NUEVOS: nunca
 *   habrían recibido ese oyente y la lupa no habría abierto, sin dar ningún
 *   error. Con un solo oyente en el documento, funciona igual la primera foto
 *   que la de la página nueve.
 */
function lightboxGaleria() {
  const lightbox = document.querySelector('.lightbox');
  if (!lightbox) return;

  const cuerpo = lightbox.querySelector('.lightbox__cuerpo');
  let ultimoOrigen = null;

  lightbox.setAttribute('role', 'dialog');
  lightbox.setAttribute('aria-modal', 'true');
  lightbox.setAttribute('aria-label', 'Vista ampliada de la foto');
  lightbox.setAttribute('tabindex', '-1');

  const cerrar = () => {
    lightbox.classList.remove('lightbox--abierto');
    cuerpo.replaceChildren();
    if (ultimoOrigen) ultimoOrigen.focus();
  };

  document.addEventListener('click', (e) => {
    const enlace = e.target.closest('.ficha__enlace');
    if (!enlace) return;

    e.preventDefault();
    const media = enlace.querySelector('.ficha__media');
    if (!media) return;

    ultimoOrigen = enlace;
    // Se CLONAN los nodos que ya están en la página en vez de copiar HTML:
    // no hay cadena que analizar, así que no hay nada que sanear.
    cuerpo.replaceChildren(...Array.from(media.cloneNode(true).childNodes));
    lightbox.classList.add('lightbox--abierto');
    lightbox.focus();
  });

  lightbox.addEventListener('click', cerrar);
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && lightbox.classList.contains('lightbox--abierto')) {
      cerrar();
    }
  });
}

/**
 * Formulario de contacto: arma el mensaje y abre WhatsApp.
 * Sustituye al onsubmit= en línea, que la CSP bloquea.
 */
function formularioWhatsApp() {
  const form = document.querySelector('[data-whatsapp-form]');
  if (!form) return;

  form.addEventListener('submit', (e) => {
    e.preventDefault();

    const numero = form.dataset.whatsappNumero || '';
    const nombre = form.querySelector('#nombre')?.value.trim() || '';
    const telefono = form.querySelector('#telefono')?.value.trim() || '';
    const mensaje = form.querySelector('#mensaje')?.value.trim() || '';

    const cuerpo = `Hola, soy ${nombre} (tel. ${telefono}). ` +
      (mensaje || 'Quisiera más información de El Chulo Tacos de Asada.');

    // location.assign en vez de window.open: los bloqueadores de popups
    // cancelan el segundo, y aquí la navegación es intencional del usuario.
    window.location.assign(`https://wa.me/${numero}?text=${encodeURIComponent(cuerpo)}`);
  });
}

/**
 * Botón para mostrar u ocultar una contraseña.
 *
 * El botón viene con [hidden] desde el HTML y se revela aquí: sin JS no tiene
 * sentido enseñar un control que no haría nada. En un celular, poder
 * comprobar lo que se tecleó evita la mitad de los intentos fallidos.
 */
function verContrasena() {
  document.querySelectorAll('[data-ver-clave]').forEach((boton) => {
    const campo = document.getElementById(boton.dataset.verClave);
    if (!campo) return;

    boton.hidden = false;

    boton.addEventListener('click', () => {
      const visible = campo.type === 'text';
      campo.type = visible ? 'password' : 'text';
      boton.setAttribute('aria-pressed', String(!visible));
      boton.setAttribute('aria-label', visible ? 'Mostrar la contraseña' : 'Ocultar la contraseña');

      // Los dos iconos ya están en el HTML; el CSS decide cuál se ve según
      // este modificador. Así no hace falta inyectar marcado desde aquí.
      boton.classList.toggle('campo-clave__ojo--viendo', !visible);

      // Devolver el foco al campo, en la misma posición del cursor.
      const pos = campo.value.length;
      campo.focus();
      campo.setSelectionRange(pos, pos);
    });
  });
}
